export default __webpack_public_path__ + "static/media/국민청원.c1aa16c3.png";